import { styled } from 'styled-components'
import { onMediumScreen } from 'mixtiles-web-common'
import { Link } from 'react-router'

export const Container = styled.div`
  font-weight: 500;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 20px;
  background: ${({ theme }) => theme.colors.grayAccent};
  ${onMediumScreen()} {
    justify-content: center;
    gap: 20px;
    padding: 12px 0;
  }
`

export const Image = styled.img`
  border-radius: 10px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  width: 64px;
  height: 64px;

  ${onMediumScreen()} {
    width: 56px;
    height: 56px;
  }
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  color: ${({ theme }) => theme.colors.secondaryDark};
  width: 176px;
  font-size: 14px;

  ${onMediumScreen()} {
    font-size: 16px;
    gap: 11px;
    flex-direction: row;
    width: fit-content;
  }
`

export const Title = styled.div`
  font-weight: 700;
  color: ${({ theme }) => theme.colors.black};
  line-height: 117%;
`

export const Subtitle = styled.div`
  font-weight: 500;
  line-height: 121%;
  letter-spacing: -0.14px;
  opacity: 0.8;
  white-space: pre-line;

  ${onMediumScreen()} {
    white-space: initial;
  }
`

export const TryNow = styled(Link)`
  border-radius: 40px;
  background: rgba(181, 167, 172, 0.27);
  color: ${({ theme }) => theme.colors.black};
  font-size: 12px;
  font-weight: 500;
  line-height: 25px;
  width: 67px;
  height: 25px;
  cursor: pointer;
  text-align: center;
  text-decoration: none;
  transition: background 0.2s;

  &:hover {
    background: rgba(181, 167, 172, 0.45);
  }
`
